import { ImSpinner8 } from 'react-icons/im';

export const loader = (
  <div className="fixed left-0 top-0 w-full h-full flex justify-center items-center bg-white opacity-90 z-50">
    <ImSpinner8 className="animate-spin text-[#ef8018] text-5xl" />
  </div>
);
